import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import {
  AngularFirestore,
  AngularFirestoreCollection,
} from "@angular/fire/firestore";
import { FirestoreService } from "app/services/firestore.service";
import { TranslationService } from "app/services/translation.service";

interface TileSet {
  name_de: string;
  name_en: string;
  icon_url: string;
  image_url: string;
  download_url: string;
  images: string[];
}

@Component({
  selector: "app-test",
  templateUrl: "./test.component.html",
  styleUrls: ["./test.component.scss"],
})
export class TestComponent implements OnInit {
  mv_tiles;
  i18n;

  constructor(
    public firestore_service: FirestoreService,
    public tranlation_service: TranslationService
  ) {}

  ngOnInit() {
    this.i18n = this.tranlation_service.getDictionary();
  }

  getCollection() {
    this.firestore_service
      .getMvTiles()
      .subscribe((tiles) => console.log(tiles));
  }
}
